import React from "react";

import { DatePickerButton } from "halifax";

import { DesktopCalendarPicker } from "../DesktopCalendarPicker";
import { ConnectedCalendarPickerButtonProps } from "./container";
import * as textConstants from "./textConstants";
import H from "history";

import "./styles.scss";

export interface CalendarPickerButtonProps
  extends ConnectedCalendarPickerButtonProps {
  classes?: string[];
  hideSeparator?: boolean;
  hasMissingSearchInfoError?: boolean;
  onClick?: () => void;
  onSearchDates?: (history: H.History) => void;
  isSearchButton?: boolean;
}

export const CalendarPickerButton = ({
  classes = [],
  fromDate,
  hideSeparator,
  openDatesModal,
  setOpenDatesModal,
  untilDate,
  hasMissingSearchInfoError,
  onClick,
  onSearchDates,
  isSearchButton,
}: CalendarPickerButtonProps) => {
  const onClickDefault = () => {
    setOpenDatesModal(true);
  };

  return (
    <DatePickerButton
      startDate={fromDate}
      endDate={untilDate}
      startLabel={textConstants.CHECK_IN}
      endLabel={textConstants.CHECK_OUT}
      classes={["hotel-inline-juncture-input", ...classes]}
      hideSeparator={hideSeparator}
      renderCalendarPopup={(props) => (
        <DesktopCalendarPicker
          {...props}
          open={openDatesModal}
          closePopup={() => {
            setOpenDatesModal(false);
            props?.closePopup?.();
          }}
          onSearchDates={onSearchDates}
          isSearchButton={isSearchButton}
        />
      )}
      onClick={onClick ?? onClickDefault}
      dateFormat={"ddd, MMM D"}
      hasMissingSearchInfoError={hasMissingSearchInfoError}
    />
  );
};
